import { FC } from 'react';
import { PageContainer } from '@edikk-edikk/country-layout-black';
import { useClassNamesWithStyle } from '@edikk-edikk/country-frontend';
import { CardLocationHeader, CardLocationBody } from '#home/components/card-location';
import { useBaseContext } from '#base/hooks/use-base-context';
import CardCss from '#srcCssModules/card/card.module.scss';
import homeContentCss from '#home/asssets/home-content.module.scss';

const CardLocation: FC = () => {
  const { hasCityList, isSingleCity } = useBaseContext();
  const classNamesWithStyle = useClassNamesWithStyle();

  if (!hasCityList || isSingleCity) {
    return null;
  }

  return (
    <PageContainer additionalClassName={homeContentCss.homeContent__cardHolder}>
      <div
        className={classNamesWithStyle(
          CardCss.card,
          CardCss.card_styleDefault,
          CardCss.card_styleRed,
        )}
      >
        <CardLocationHeader />
        <CardLocationBody />
      </div>
    </PageContainer>
  );
};

export { CardLocation };
